import { useQuery } from '@tanstack/react-query';

import { toAsync } from '@client/new/helpers/reactQuery';
import type { Async } from '@client/new/helpers/types';

import { AutomationStepPreview, getAutomationSteps } from '../automations.api';
import { automationKeys } from '../automations.keys';
import { AutomationInsightsError } from './AutomationInsights.model';
import { errorKindOf } from './Automations.model';

/** Copy is not creator specific today, so the timeline is cached per type
 *  for the session; `staleTime` keeps reopening the modal free. */
export const useAutomationStepsModel = (
  creatorId: number,
  automationType: string,
): Async<AutomationStepPreview[], AutomationInsightsError> => {
  const query = useQuery({
    queryKey: automationKeys.steps(creatorId, automationType),
    queryFn: async () =>
      (await getAutomationSteps(creatorId, automationType)).steps,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  return toAsync(query, (error) => ({
    kind: errorKindOf(error),
    retry: async () => {
      await query.refetch();
    },
  }));
};
